export const INPUT_VARIABLE_COLOR = '#7B61FF'
export const NODE_VARIABLE_COLOR = '#38A6FF'
